import { render } from "./fygfEventClub.vue?vue&type=template&id=406da993"
import script from "./fygfEventClub.vue?vue&type=script&lang=js"
export * from "./fygfEventClub.vue?vue&type=script&lang=js"

import "./fygfEventClub.vue?vue&type=style&index=0&id=406da993&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__